import React from 'react'
import Header from '../Components/Header'
import { Outlet, useLocation } from 'react-router-dom'
import Footer from '../Pages/Footer'
import AdPopup from '../Components/AdPopup'
import CompareBar from '../Components/CompareBar'

const MyLayout = () => {
  const location = useLocation()
  const isHome = location.pathname === '/'

  return (
    <div className={`app-layout ${isHome ? 'app-layout--home' : 'app-layout--inner'}`}>
      <AdPopup />
      <Header />
      <main className="app-main">
        <Outlet />
      </main>
      <Footer />
      <CompareBar />
    </div>
  )
}

export default MyLayout
